<template>
  <v-app >
    <v-layout align-center justify-center >
      <v-flex xs12 sm8 md4>
      <v-row class="w-100 justify-content-center">
        <v-col md="6">
          <div class="w-100">
            <div class="clearfix">
              <b-img :src="img" ></b-img>
              <h2 class="pt-3"> خطای سرور </h2>
              <p class="text-muted">لطفا با پشبیانی تماس بگیرید</p>
            </div>
            <v-row class="w-100 justify-content-center">
              <v-col md="6">
                <v-btn
                    @click="$router.go(-1)"
                    block
                    class="primary"
                >
                  برگشت
                </v-btn>
              </v-col>
              <v-col md="6">
                <v-btn
                    to="/home"
                    block
                    class="info "
                >

                  داشبورد
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
      </v-flex>
    </v-layout>
  </v-app>

</template>

<script>
export default {
  name: 'pageNetError',
  data(){
    return{
      img:require('../../assets/net.png')
    }
  }
}
</script>
<style>
@import "../../assets/styles/global.css";
@import '../../../node_modules/vuetify/dist/vuetify.min.css';
</style>